export default __webpack_public_path__ + "static/media/placeholder.6e33a3c8.jpg";